import { Component, OnInit, ViewChild } from '@angular/core';
import { DataManager, WebApiAdaptor, Query} from '@syncfusion/ej2-data';
import { GridComponent, PageSettingsModel, SelectionSettingsModel, ToolbarItems, RowDataBoundEventArgs } from '@syncfusion/ej2-angular-grids';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { debounceTime, distinctUntilChanged, filter, finalize, switchMap, tap } from 'rxjs/operators';
import { isNumber } from 'highcharts';
import { MatDialog } from '@angular/material/dialog';

import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

import { MenuFuncionService, ComunidadService, EstadoService, PedidoService, TipoMaterialService, RubroContableService } from '../../../../src/app/shared/services';
import { GridPageSettings, MenuFuncionCodes, Pedido, SearchPedidoRequestDto, SearchTipoMaterialRequest, TipoMaterialDto, PedidoDto, Comunidad, SearchComunidadRequest,
  SearchEstadoRequest, Estado, Rol, RubroContable, SearchRubroContableRequest, DialogConfirmResponse, DialogConfirmRequest, BajaMasivaPedidosDto
 } from '../../../../src/app/shared/model';

import { DialogConfirmComponent } from '../../../../src/app/shared/components/modals/dialogConfirm.component';
import { ExportMediaTypeConstants } from '../../shared/model';

@Component({
  selector: 'app-pedidoLista',
  templateUrl: './pedidoLista.component.html',
  styleUrls: ['./pedidoLista.component.scss'],
})

export class PedidoListaComponent implements OnInit {
  @ViewChild('grid')
  public grid: GridComponent;

  public data: DataManager;

  isValidating: boolean = false;
  isSearching: boolean = false;
  isTipoMaterialSearching: boolean = false;
  isExporting: boolean = false;
  isExportingItem: boolean = false;
  isTipoSearching: boolean = false;
  isComunidadSearching: boolean = false;
  isEstadoSearching: boolean  = false;
  isRolSearching: boolean = false;
  isRubroContableSearching: boolean = false;
  isDeleting: boolean = false;
  isDeletingMasivo: boolean = false;

  canEdit: boolean = false;
  canView: boolean = false;
  canAdd: boolean = false;
  canDelete: boolean = false;
  multiSelectionEnabled: boolean = false;

  filteredComunidadesList: Comunidad[];
  comunidadList: Comunidad[];
  tipoMaterialList: TipoMaterialDto[] = [];
  estadoList: Estado[];
  rolList: Rol[];
  rubroContableList: RubroContable[];
  filteredRubroContableList: RubroContable[];

  total: number = 0;
  searchForm: FormGroup;
  item: PedidoDto;

  public query: Query;
  public selectionOptions: SelectionSettingsModel;
  public pageSizes: number[];
  public toolbarOptions: ToolbarItems[];
  public pageSettings: PageSettingsModel;

  constructor(
    public sharedFunctions: SharedFunctions,
    private formBuilder: FormBuilder,
    private router: Router,
    private menuService: MenuFuncionService,
    private tipoMaterialService: TipoMaterialService,
    private datePipe: DatePipe,
    private comunidadService: ComunidadService,
    private estadoService: EstadoService,
    private rubroContableService: RubroContableService,
    private pedidoService: PedidoService,
    public dialog: MatDialog
    ) {}

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenuPadre(MenuFuncionCodes.PEDIDO).subscribe(data => {
      this.isValidating = false;
      if (data != null && data.Success && data?.Result) {
        this.canAdd = data.Result.some(x => x == MenuFuncionCodes.PEDIDO_ADD);
        this.canView = data.Result.some(x => x == MenuFuncionCodes.PEDIDO_LIST);
        this.canDelete = data.Result.some(x => x == MenuFuncionCodes.PEDIDO_DELETE);

        if (this.canView) {
          this.loadView();
        }
        else {
          this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
          this.router.navigate(['/']);
        }
      }
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.router.navigate(['/']);
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  loadView() {
    this.canView = true;
    this.buildForm();

    this.getTipoMaterial();
    //this.getAutocompleteComunidadeOrigen();
    //this.getAutocompleteComunidadeDestino();
    this.getComunidades();
    this.getEstados();
    this.getRoles();
    this.getRubroContable();

    this.pageSizes = GridPageSettings.PageSizeList;
    this.pageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[1], pageSizes: this.pageSizes };


    var filtros = this.sharedFunctions.getReporteFiltros("app-pedidoLista");
    if (filtros != null) {
      this.searchForm.patchValue(filtros);
      if (filtros.gridPage != null && filtros.gridPage > 0)
        this.pageSettings.currentPage = filtros.gridPage;
    }

    this.setQueryParams();

    this.data = new DataManager({
      url: this.pedidoService.getSearchUrl(),
      adaptor: new WebApiAdaptor(),
      headers: [this.pedidoService.getAuthorizationHeader(),this.pedidoService.getTenantHeader()]
    });
  }

  displayComunidad(comunidad: Comunidad): string {
    var displayWith = this.sharedFunctions.formatComunidadName(comunidad);
    return displayWith;
  }

//#region forms

  buildForm() {
    this.searchForm = this.formBuilder.group({
      'TipoMaterialId': [null],
      'RolId': [null],
      'PedidoId': [null],
      /*'ComunidadOrigen': [null],
      'ComunidadDestino': [null],*/
      'ComunidadesOrigen': [null],
      'ComunidadesDestino': [null],
      'Estados': [null],
      'RubroContableId': [0],
      'FechaNecesidadDesde': [null],
      'FechaNecesidadHasta': [null],
      'VerSoloMisPendientesAprobacion': [true],
      'VerSoloPedidosSinRemitoAdjunto': [false],
      'VerSoloActivos': [true],
      'gridPage': [1],
      'OrderAscending': [true],
      'OrderFieldName': [null]
    });
  }

//#endregion

//#region getters

  getRoles() {
    this.isRolSearching = true;
    this.pedidoService.getAprobadores().subscribe(data => {
      this.isRolSearching = false;
      if (data != null)
        this.rolList = data?.Result;
    },
    (err: HttpErrorResponse) => {
      this.isRolSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getRubroContable() {
    var r = new SearchRubroContableRequest(null, null, null, 'Nombre', null, null, true)
    this.isRubroContableSearching = true;
    this.rubroContableService.search(r).subscribe(data => {
      this.isRubroContableSearching = false;
      this.rubroContableList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isRubroContableSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getTipoMaterial() {
    var r = new SearchTipoMaterialRequest(null, null, true, "Nombre", null, null, true);
    this.isTipoMaterialSearching = true;

    this.tipoMaterialService.search(r).subscribe(data => {
      this.isTipoMaterialSearching = false;
      this.tipoMaterialList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isTipoMaterialSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getComunidades(){
    var r = new SearchComunidadRequest(null, null, true, "Nombre", "", null, null, null, null, true);
    this.isComunidadSearching = true;
    this.comunidadService.search(r).subscribe(data => {
      this.isComunidadSearching = false;
      this.comunidadList = data?.result;
    },(err: HttpErrorResponse) => {
      this.isComunidadSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getEstados() {
    var r = new SearchEstadoRequest(null, null, true, "Nombre", null, null, true);
    this.isEstadoSearching = true;

    this.estadoService.searchPedidoEstados(r).subscribe(data => {
      this.isEstadoSearching = false;
      this.estadoList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isEstadoSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getAutocompleteComunidadeOrigen() {
    this.searchForm.get("ComunidadOrigen")?.valueChanges
    .pipe(
    filter(res => {
        return res && res !== null && res.length >= 3
    }),
    distinctUntilChanged(),
    debounceTime(1000),
    tap(() => {
        this.filteredComunidadesList = [];
        this.isComunidadSearching = true;
    }),
    switchMap(value => this.comunidadService.search(new SearchComunidadRequest(50, null, true, "Nombre", !isNumber(parseInt(value)) ? value : "", null, null, null, null, true))
      .pipe(
        finalize(() => {
          this.isComunidadSearching = false;
        }),
      )
    )
    )
    .subscribe((data: any) => {
      if (data != null && data.result != null)
        this.filteredComunidadesList = data.result;
      else
        this.filteredComunidadesList = [];
    });
  }

  getAutocompleteComunidadeDestino() {
    this.searchForm.get("ComunidadDestino")?.valueChanges
    .pipe(
    filter(res => {
        return res && res !== null && res.length >= 3
    }),
    distinctUntilChanged(),
    debounceTime(1000),
    tap(() => {
        this.filteredComunidadesList = [];
        this.isComunidadSearching = true;
    }),
    switchMap(value => this.comunidadService.search(new SearchComunidadRequest(50, null, true, "Nombre", !isNumber(parseInt(value)) ? value : "", null, null, null, null, true))
      .pipe(
        finalize(() => {
            this.isComunidadSearching = false;
        }),
      )
    ))
    .subscribe((data: any) => {
      if (data != null && data.result != null)
        this.filteredComunidadesList = data.result;
      else
        this.filteredComunidadesList = [];
    });
  }

//#endregion

//#region grid

  onActionBegin(args: any) {
    if (!this.isSearching) {
      if (args.requestType === 'paging') {
        this.searchForm.get('gridPage')?.setValue(args.currentPage);
        this.sharedFunctions.setReporteFiltros("app-pedidoLista", this.searchForm.getRawValue());
      }

      if (args.requestType === 'sorting') {
        this.searchForm.get('OrderAscending')?.setValue(args.direction=="Ascending");
        this.searchForm.get('OrderFieldName')?.setValue(args.columnName);
        this.sharedFunctions.setReporteFiltros("app-pedidoLista", this.searchForm.getRawValue());
      }
    }
  }

  onGridActionFailure(event: any): void {
    this.sharedFunctions.showMessage("Ocurrió un error intentando realizar la búsqueda", "Error");
  }

  onSearch() {
    this.isSearching = true;
    if (this.searchForm.get('VerSoloMisPendientesAprobacion')?.value == true)
      this.searchForm.get('RolId')?.setValue(null);

    this.searchForm.get('gridPage')?.setValue(1);
    this.searchForm.get('OrderAscending')?.setValue(true);
    this.searchForm.get('OrderFieldName')?.setValue(null);
    this.sharedFunctions.setReporteFiltros("app-pedidoLista", this.searchForm.getRawValue());

    this.setQueryParams();
    this.grid.refresh();

    this.isSearching = false;
  }

  setQueryParams() {
    if (this.query == null)
      this.query = new Query();

    var index = this.query.params.findIndex(obj => obj.key === "TipoMaterialId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.TipoMaterialId;
    else
      this.query.addParams("TipoMaterialId",this.searchForm.value.TipoMaterialId);

    index = this.query.params.findIndex(obj => obj.key === "RolId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.RolId;
    else
      this.query.addParams("RolId", this.searchForm.value.RolId);

    index = this.query.params.findIndex(obj => obj.key === "RubroContableId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.RubroContableId;
    else
      this.query.addParams("RubroContableId", this.searchForm.value.RubroContableId);

    index = this.query.params.findIndex(obj => obj.key === "PedidoId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.PedidoId;
    else
      this.query.addParams("PedidoId", this.searchForm.value.PedidoId);

    /*index = this.query.params.findIndex(obj => obj.key === "ComunidadOrigenId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.ComunidadOrigen?.Id;
    else
      this.query.addParams("ComunidadOrigenId", this.searchForm.value.ComunidadOrigen?.Id);

    index = this.query.params.findIndex(obj => obj.key === "ComunidadDestinoId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.ComunidadDestino?.Id;
    else
      this.query.addParams("ComunidadDestinoId", this.searchForm.value.ComunidadDestino?.Id);*/

    index = this.query.params.findIndex(obj => obj.key === "ComunidadesOrigen");
    if(index >= 0)
      this.query.params[index].value = this.searchForm.value.ComunidadesOrigen?.join(",");
    else
      this.query.addParams("ComunidadesOrigen", this.searchForm.value.ComunidadesOrigen?.join(","));
    index = this.query.params.findIndex(obj => obj.key === "ComunidadesDestino");
    if(index >= 0)
      this.query.params[index].value = this.searchForm.value.ComunidadesDestino?.join(",");
    else
      this.query.addParams("ComunidadesDestino", this.searchForm.value.ComunidadesDestino?.join(","));

    index = this.query.params.findIndex(obj => obj.key === "Estados");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Estados?.join(",");
    else
      this.query.addParams("Estados", this.searchForm.value.Estados?.join(","));

    index = this.query.params.findIndex(obj => obj.key === "VerSoloMisPendientesAprobacion");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.VerSoloMisPendientesAprobacion;
    else
      this.query.addParams("VerSoloMisPendientesAprobacion", this.searchForm.value.VerSoloMisPendientesAprobacion);

    index = this.query.params.findIndex(obj => obj.key === "VerSoloPedidosSinRemitoAdjunto");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.VerSoloPedidosSinRemitoAdjunto;
    else
      this.query.addParams("VerSoloPedidosSinRemitoAdjunto", this.searchForm.value.VerSoloPedidosSinRemitoAdjunto);

    index = this.query.params.findIndex(obj => obj.key === "VerSoloActivos");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.VerSoloActivos;
    else
      this.query.addParams("VerSoloActivos", this.searchForm.value.VerSoloActivos);

    index = this.query.params.findIndex(obj => obj.key === "OrderAscending");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.OrderAscending;
    else
      this.query.addParams("OrderAscending", this.searchForm.value.OrderAscending);

    index = this.query.params.findIndex(obj => obj.key === "OrderFieldName");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.OrderFieldName;
    else
      this.query.addParams("OrderFieldName", this.searchForm.value.OrderFieldName);
  }

//#endregion

//#region actions

  add() {
    if (this.canAdd)
      this.router.navigate(['pedido-edit', 0]);
    else
      this.sharedFunctions.showMessage("No tiene permisos para realizar esta operación", "Error");
  }

  edit(item: Pedido) {
    if (!item || item.Id == null || item.Id <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
      return false;
    }

    //this.searchForm.get("gridPage")?.setValue(this.grid.pageSettings.currentPage);
    //this.sharedFunctions.setReporteFiltros("app-pedidoLista", this.searchForm.getRawValue());

    this.router.navigate(['pedido-edit', item.Id]);
  }

  delete(item: Pedido) {
    if (!item || item.Id == null || item.Id <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
      return false;
    }

    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      width: '600px',
      data: new DialogConfirmRequest(
        "Baja de Pedido",
        "¿Está seguro que desea dar de baja el pedido?",
        null, null
      )
    });

    dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
      if (result != null && result.Accepted) {
        this.isDeleting = true;
        this.pedidoService.delete(item.Id).subscribe(data => {
          this.isDeleting = false;
          if (data != null && data.Success) {
            this.sharedFunctions.showMessage("Se dió de baja correctamente el pedido", "Operación Exitosa!");
            this.grid.refresh();
          }
          else
            this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
        },
        (err: HttpErrorResponse) => {
          this.isDeleting = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
    });
  }

  isProcessing() {
    return (this.isDeletingMasivo || this.isSearching || this.isExporting);
  }

  bajaMasiva() {
    var selectedRows = this.grid.getSelectedRecords() as Pedido[];
    if (selectedRows == null || selectedRows.length == 0) {
      this.sharedFunctions.showMessage("Debe seleccionar al menos un pedido para continuar con la operación", "Error");
      return false;
    }

    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: new DialogConfirmRequest(
        null,
        "¿Está seguro que desea dar de baja " + selectedRows.length + " pedidos seleccionados del listado?<br/><br/>" +
          "<b>Una vez dado de baja, el pedido no podrá volver a ser restaurado.</b>",
        "Sí, dar de baja todos",
        "No"
      )
    });

    dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
      if (result != null && result.Accepted) {
        this.isDeletingMasivo = true;
        this.pedidoService.bajaMasivaPedidos(new BajaMasivaPedidosDto(selectedRows.map(row => row.Id))).subscribe((data: any) =>{
          this.isDeletingMasivo = false;
          if (data.Success) {
            var msg = "Se dieron de baja " + (data.Result?.TotalOk ?? 0) + " de " + (data.Result?.Count ?? 0) + " pedidos.";

            if (data.Result != null && data.Result.Pedidos != null && data.Result.Pedidos.some(f => !f.IsValid)) {
              msg += "<br><br><b>Pedidos con errores:</b><br>";
              msg += data.Result.Pedidos.filter(f => !f.IsValid).map(s => s.Observacion).join("<br>");
            }

            this.grid.refresh();
            const dialogRef2 = this.dialog.open(DialogConfirmComponent, {
              data: new DialogConfirmRequest(
                "Resultado de Baja Masiva de Pedidos",
                msg,
                "Aceptar",
                null,
                true,
                false
              )
            });
          }
          else
            this.sharedFunctions.showMessage("Ocurrió un error al intentar ejecutar la operación", "Error");
        },
        (err: HttpErrorResponse) => {
          this.isDeletingMasivo = false;
          this.sharedFunctions.handleError(err, true);
          this.grid.refresh();
        })
      }
      else
        this.multiSelectionEnabled = false;
    });
  }

  onExport() {
    var search = new SearchPedidoRequestDto(null, null, null, "", null, null, null, null, null, true, 0, null, null);
    search = Object.assign(search, this.searchForm.value);

    this.isExporting = true;
    this.pedidoService.exportSearch(search).subscribe((data: Blob) => {
      this.isExporting = false;
      var fileUrl = URL.createObjectURL(data);

      var anchor = document.createElement("a");
      anchor.download = "Pedidos_" + this.datePipe.transform(new Date(),"yyyy-MM-dd") + this.sharedFunctions.getFileExtension(ExportMediaTypeConstants.Csv);
      anchor.href = fileUrl;
      anchor.click();
    },
    (err: HttpErrorResponse) => {
      this.isExporting = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  onExportItem() {
    var search = new SearchPedidoRequestDto(null, null, null, "", null, null, null, null, null, true, 0, null, null);
    search = Object.assign(search, this.searchForm.value);

    this.isExportingItem = true;
    this.pedidoService.exportSearchWithItems(search).subscribe((data: Blob) => {
      this.isExportingItem = false;
      var fileUrl = URL.createObjectURL(data);

      var anchor = document.createElement("a");
      anchor.download = "PedidosConMateriales_" + this.datePipe.transform(new Date(),"yyyy-MM-dd") + this.sharedFunctions.getFileExtension(ExportMediaTypeConstants.Csv);
      anchor.href = fileUrl;
      anchor.click();
    },
    (err: HttpErrorResponse) => {
      this.isExportingItem = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

//#endregion

  rowDataBound(args: RowDataBoundEventArgs) {
    const fechaPorVencer = 'TieneFechaPorVencer';
    if(args.data){
      const tieneFechaPorVencer: boolean = args.data[fechaPorVencer];
      if(tieneFechaPorVencer) {
        args.row?.classList.add('critical');
      }
    }
  }
}
